import React, { useEffect, useState, useMemo } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import MapOverlay from "./MapOverlay";
import { authFetch } from "../api/api";
export default function MapPage({ selectedOrders }) {
  const [cities, setCities] = useState([]);
  const [geo, setGeo] = useState(null);

  useEffect(() => {
    authFetch(`${process.env.REACT_APP_DJANGO_BACKEND}/api/cities/`)
      .then((r) => r.json())
      .then(setCities);

    fetch("https://raw.githubusercontent.com/johan/world.geo.json/master/countries.geo.json")
      .then((r) => r.json())
      .then(setGeo);
  }, []);

  const cityMap = useMemo(() => {
    const m = new Map();
    cities.forEach((c) => m.set(c.id, c));
    return m;
  }, [cities]);

  const groups = useMemo(() => {
    const m = new Map();

    selectedOrders?.forEach((o) => {
      const d = cityMap.get(o.destination_city);
      if (!d) return;

      if (!m.has(d.id)) {
        m.set(d.id, { city: d, suppliers: [], warehouses: [], orders: [] });
      }

      m.get(d.id).orders.push(o.order_code);

      o.items?.forEach((i) => {
        const s = i?.product_data?.supplier;
        const sc = cityMap.get(s?.city_id);
        if (!sc) return;

        if (!m.has(sc.id)) {
          m.set(sc.id, { city: sc, suppliers: [], warehouses: [], orders: [] });
        }

        m.get(sc.id).suppliers.push(s);
      });

      const w = o.expeditor_warehouse_data;
      const wc = cityMap.get(w?.city);

      if (wc) {
        if (!m.has(wc.id)) {
          m.set(wc.id, { city: wc, suppliers: [], warehouses: [], orders: [] });
        }

        m.get(wc.id).warehouses.push(w);
      }
    });

    return Array.from(m.values());
  }, [selectedOrders, cityMap]);

  return (
    <MapContainer
      center={[30, 100]}
      zoom={3}
      style={{ height: "100vh", background: "#05060a" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      {geo && (
        <GeoJSON
          data={geo}
          style={{
            color: "#00fff2",
            weight: 0.5,
            fillOpacity: 0.02,
          }}
        />
      )}

      <MapOverlay groups={groups} />
    </MapContainer>
  );
}